import { Button } from '@/components/ui/button';
import PaddockAvatar from '@/components/ui/paddock-avatar/paddock-avatar';
import { PDKNoUserIcon } from '@/components/ui/pdk-icons';
import useUsers from '@/hooks/use-users';
import { cn } from '@/lib/utils.ts';
import type { Deal } from '@/models/registry';

const SalesRepBadge = ({
  salesRep,
  hideCopy = false,
  useAbbreviations = false,
  className,
}: {
  salesRep: Deal['primary_sales_rep'] | Deal['secondary_sales_rep'];
  hideCopy?: boolean;
  useAbbreviations?: boolean;
  className?: string;
}) => {
  const { salesReps } = useUsers();

  return (
    <Button variant="ghost" className={cn('p-1 h-fit w-fit', className)}>
      {salesRep && (
        <div className="flex flex-row gap-2 items-center">
          <PaddockAvatar
            src={salesRep.avatar}
            alt={`${salesRep.first_name} ${salesRep.last_name}`}
            fallback={`${salesRep.first_name.charAt(0)} ${salesRep.last_name.charAt(0)}`}
            className="size-5 rounded-full"
          />
          {!hideCopy && (
            <p className="rounded text-xs  text-gray-600">
              {useAbbreviations
                ? `${salesRep.first_name.charAt(0)}${salesRep.last_name.charAt(0)}`
                : `${salesReps.find((option) => option.id === salesRep?.id)?.first_name} ${
                    salesReps.find((option) => option.id === salesRep?.id)
                      ?.last_name
                  }`}
            </p>
          )}
        </div>
      )}
      {!salesRep && (
        <div className="flex flex-row gap-2 items-center">
          <PDKNoUserIcon className="size-5! text-gray-300" />
          {!hideCopy && (
            <p className="rounded text-xs  text-gray-600">
              {useAbbreviations ? 'Add SR' : 'Add sales rep'}
            </p>
          )}
        </div>
      )}
    </Button>
  );
};

export default SalesRepBadge;
